import { createSlice } from "@reduxjs/toolkit";
import {
  RegionalInitialStatus,
  regionHubData,
} from "../../../../types/geo/regionalHub";
import {
  createRegionalHubAsync,
  getAllRegionalHubAsync,
  updateRegionalHubAsync,
} from "./regionApi";

const initialState: RegionalInitialStatus<regionHubData> = {
  loading: false,
  manageLoading: false,
  regionHubList: [],
  countRegionHub: 0,
};

const regionalHubSlice = createSlice({
  name: "admin-region",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createRegionalHubAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createRegionalHubAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createRegionalHubAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all region hub
    builder
      .addCase(getAllRegionalHubAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllRegionalHubAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.regionHubList = action.payload.data;
        state.countRegionHub = action.payload.length;
      })
      .addCase(getAllRegionalHubAsync.rejected, (state) => {
        state.loading = false;
        state.regionHubList = [];
        state.countRegionHub = 0;
      });

    // update
    builder
      .addCase(updateRegionalHubAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateRegionalHubAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateRegionalHubAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default regionalHubSlice;
